import { Stack } from '@mui/material';
import { Section, CompaniesCarousel } from '@rumblefish/ui/Rumblefish23Theme';
import React from 'react';

import type { HeroProps } from './LetsDiscuss.types';
import {
  StyledImg,
  StyledLink,
  StyledText,
  StyledStack,
  StyledTitle,
  StyledButton,
  StyledFeature,
  StyledWrapper,
  StyledBigWhite,
  StyledHowItWorks,
  StyledTwoFeatures,
  StyledButtonWrapper,
  CompaniesStyledStack,
  StyledCompaniesHeader,
} from './styles';

export const LetsDiscuss = ({ ...props }: HeroProps) => {
  return (
    <Section width="small">
      <StyledStack {...props}>
        <StyledWrapper>
          <Stack
            width={'100%'}
            display={{ xs: 'none', sm: 'flex' }}
            alignItems={'center'}>
            <StyledImg />
            <StyledTitle>
              Let's discuss <br />
              the details of your project!
            </StyledTitle>
            <StyledButtonWrapper>
              <StyledLink to="/contact">
                <StyledButton>Book a free consultation</StyledButton>
              </StyledLink>
            </StyledButtonWrapper>
          </Stack>
          <StyledHowItWorks>
            <StyledText>
              <p>How does it work?</p>
              <StyledBigWhite>
                Our expert consultants will become your experienced partners and
                help you set your business for success. We offer end-to-end
                solutions that include idea validation, discovery workshops,
                technology consultancy & software development, UX services, and
                anything in between you might need to make your startup a
                successful one. <b>Here’s how our process looks like:</b>
              </StyledBigWhite>
            </StyledText>
            <StyledTwoFeatures>
              <StyledFeature>
                <p>Get a free startup consulting session</p>
                <span>
                  Get in touch with us to help yourself with a free consulting
                  session with our experts. During this initial conversation, we
                  get to know each other and learn more about your product
                  concept. Then we share our ideas on how to make your startup a
                  success and continue with conceptual work.
                </span>
              </StyledFeature>
              <StyledFeature>
                <p>Set the pace as you go</p>
                <span>
                  After learning more about us and our process, you can set the
                  pace however you please. We can work with you from start to
                  finish, or you can use our hands-on experience at any stage of
                  the process. It’s all about making your business work!
                </span>
              </StyledFeature>
            </StyledTwoFeatures>
          </StyledHowItWorks>

          <CompaniesStyledStack>
            <StyledCompaniesHeader variant="strong_400">
              Check out those successful startups <br />
              that worked with us and join them
            </StyledCompaniesHeader>
            <CompaniesCarousel />
          </CompaniesStyledStack>
        </StyledWrapper>
      </StyledStack>
    </Section>
  );
};
